import { NavLink } from 'react-router-dom'

interface DashboardLink {
  id: string
  name: string
  route: string
}

// Dashboard navigation items - EXACT order from Tableau Dec 22 2025 .twb window order
const DASHBOARDS: DashboardLink[] = [
  { id: 'welcome', name: 'Welcome', route: '/welcome' },
  { id: 'how-to-navigate', name: 'How to Navigate', route: '/how-to-navigate' },
  { id: 'demographics-general', name: 'Demographics - General', route: '/demographics-general' },
  { id: 'demographics-details', name: 'Demographics - Details', route: '/demographics-details' },
  { id: 'identity', name: 'Identity', route: '/identity' },
  { id: 'identity-statements', name: 'Identity - Statements', route: '/identity-statements' },
  { id: 'scatterplot', name: 'Values Map', route: '/scatterplot' },
  { id: 'most-least', name: 'Most/Least Important', route: '/most-least' },
  { id: 'values-and-issues', name: 'Values and Issues', route: '/values-and-issues' },
  { id: 'beliefs-and-doubts', name: 'Beliefs and Doubts', route: '/beliefs-and-doubts' },
  { id: 'future-threats', name: 'Future Threats to Canada', route: '/future-threats' },
  { id: 'environmental-concerns', name: 'Environmental Concerns', route: '/environmental-concerns' },
  { id: 'protected-areas', name: 'Protected Areas', route: '/protected-areas' },
  { id: 'activities-in-parks', name: 'Activities in Parks', route: '/activities-in-parks' },
  { id: 'paired-statements', name: 'Views and Opinions', route: '/paired-statements' },
  { id: 'confidence-in-sources', name: 'Confidence in Information Sources', route: '/confidence-in-sources' },
  { id: 'reasons-to-create', name: 'Reasons to Create Protected Areas', route: '/reasons-to-create' },
  { id: 'reasons-not-to-create', name: 'Reasons Not to Create Protected Areas', route: '/reasons-not-to-create' },
  { id: 'support-ipas-and-parks', name: 'Support for More Parks', route: '/support-ipas-and-parks' },
  { id: 'indigenous-protected-areas', name: 'Indigenous Protected Areas', route: '/indigenous-protected-areas' },
  { id: 'how-much-protected', name: 'How Much Should Be Protected', route: '/how-much-protected' },
  { id: 'party-support', name: 'Voter Intention', route: '/party-support' },
  { id: 'federal-leaders', name: 'Federal Leaders', route: '/federal-leaders' },
  { id: 'provincial-leaders', name: 'Provincial Leaders', route: '/provincial-leaders' },
  // TEMP DISABLED: { id: 'coalition', name: 'Coalition Building', route: '/coalition' },
]

export function Sidebar() {
  return (
    <aside className="w-64 bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 overflow-y-auto h-[calc(100vh-3.5rem)]">
      <nav className="p-3">
        <ul className="space-y-1">
          {DASHBOARDS.map((dashboard) => (
            <li key={dashboard.id}>
              <NavLink
                to={dashboard.route}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-lg text-sm transition-colors ${
                    isActive
                      ? 'bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300 font-medium'
                      : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700'
                  }`
                }
              >
                {dashboard.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}

export { DASHBOARDS }
